module.exports = __webpack_public_path__ + "static/media/Surfboard_Button.dd654fd4.svg";